<template>
  <div class="privacy">
    <header-top :headerPosition="false">
      <div slot="title">授权协议</div>
    </header-top>
    <div class="privacy-wrapper">
      <div class="privacy-content">欢迎您使用成都陌陌科技有限公司为您提供的服务</div>
      <div class="privacy-content"></div>
      <div class="privacy-content">
        为了使您得到更好的社交体验，可跨平台的浏览关联版本中用户发布的内容、与其用户交流、分享您发布的内容等目的。您理解并同意本《授权协议》（以下称“本协议”），即：在关联版本
        {{ resultStr }}（前述应用均由成都陌陌科技有限公司运营）中共享信息。
      </div>
      <div class="privacy-content">一、信息共享</div>
      <div class="privacy-content">
        您同意授权我们将您在本应用内形成的以下信息及内容，共享至关联版本应用予以展示、使用：
      </div>
      <div class="privacy-content">1、账号信息</div>
      <div class="privacy-content">
        您同意我们共享您在注册、登录本应用过程中提供的相关信息，包括昵称、性别、生日、手机号等；如您在本应用根据自身需求提供了头像、身高、标签等公开资料的，我们将同时为您共享前述相关信息。
      </div>
      <div class="privacy-content">2、发布、互动</div>
      <div class="privacy-content">
        您同意我们共享您在本应用内发布的内容和信息（包括音视频、图文、直播等）。授权后，您在本应用内对相关内容或信息进行增加、删除或变更的，都会在关联版本应用内自动共享，但本协议另有约定的除外。
      </div>
      <div class="privacy-content">
        您同意我们共享您在使用本应用服务过程中的互动信息，包括评论、点赞等。
      </div>
      <div class="privacy-content">
        3、为向您提供完整的升级服务，您同意我们向关联版本应用提供为达成此目的所必须的您在本应用内的其他信息与内容。
      </div>
      <div class="privacy-content">二、其他</div>
      <div class="privacy-content">
        1、您理解并同意，基于技术限制、应用功能差异、授权范围限制、运营策略差异等原因，即使在您按照本协议授权后，您在本应用内发布、选择公开或形成的部分信息，仍无法被共享到关联版本应用或在共享至关联版本应用后可能仍然无法被完整展示或使用。我们将继续努力完善您的相关体验。
      </div>
      <div class="privacy-content">
        2、您依据本协议作出授权后，我们仍会根据各自应用隐私政策使用、保护、共享您的个人信息。如您对本协议有任何疑问或您需要撤回或随时终止您的授权，可通过平台客服与我们联系。
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.tab1 {
  margin: 0 auto;
  margin-bottom: 20px;
  line-height: 30px;
  color: #9a9eb9;
  text-align: center;
  border-color: #eee;
  tr {
    font-size: 16px;
  }
  .tr1 {
    width: 100px;
  }
  .tr2 {
    min-width: 40px;
  }
  .tr3 {
    width: 80px;
  }
  .tr4 {
    width: 100px;
  }
  .tr5 {
    max-width: 350px;
    word-break: break-all;
  }
}
.thead {
  color: #3f446f;
  font-size: 24px;
  line-height: 30px;
  margin-top: 7px;
  text-align: center;
}
.privacy {
  background-color: #f6f5fb;
}
.privacy-wrapper {
  padding-top: 120px;
  padding: 120px 30px 0 30px;
  width: 690px;
  text-align: left;
}
.privacy-title {
  margin-bottom: 40px;
  font-family: "PingFangSC-Medium";
  font-size: 30px;
  color: rgb(63, 68, 111);
}
.privacy-date {
  margin-left: 300px;
  margin-bottom: 4px;
  text-align: right;
  font-size: 26px;
  width: 390px;
  color: #3f446f;
}
.privacy-date-second {
  margin-bottom: 20px;
}
.privacy-content {
  font-size: 26px;
  color: #3f446f;
  line-height: 41px;
  padding-bottom: 40px;
  .phone {
    text-decoration: underline;
  }
}
</style>
<script>
import HeaderTop from "src/components/HeaderTop.vue";

const { mm } = window;
export default {
  name: "Privacy",
  data() {
    return {
      IOSUser: false,
      isDd: this.$route.query.isDd,
      appName: this.$store.state.appName
    };
  },
  computed: {
    resultStr() {
      let str = "";
      if (this.appName === "对对") {
        str = "“心配APP”、“心甜APP”、“依恋APP”";
      }
      if (this.appName === "心甜") {
        str = "“对对APP”、“心甜APP”、“依恋APP”";
      }
      if (this.appName === "心配") {
        str = "“对对APP”、“心甜APP”、“依恋APP”";
      }
      if (this.appName === "依恋") {
        str = "“对对APP”、“心甜APP”、“心配APP”";
      }
      if (this.appName === "缘已") {
        str = "“对对APP”、“心甜APP”、“心配APP”";
      }
      return str;
    }
  },
  mounted() {
    const scrollBox = document.documentElement || document.body;
    scrollBox.scrollTop = 0;
  },
  components: {
    "header-top": HeaderTop // 顶部导航组件
  },
  created() {
    const iOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (iOS) {
      this.IOSUser = iOS;
      // console.log("iOS终端", iOS);
    }
  },
  methods: {
    callServe(phone) {
      mm.ui.openUrl({
        target: 3,
        url: ` goto://MultiFunction_Action_Protocol?action=dail&content=${phone}`
      });
    }
  }
};
</script>
